'use strict';
(function () {
	angular.module('dat.shared-components.company')
		.factory('CompanyService', companyService);

	companyService.$inject = ['$http', '$log'];

	function companyService($http, $log) {
		return {
			addOfficeFilter: addOfficeFilter,
			removeOfficeFilter: removeOfficeFilter
		};

		function addOfficeFilter(officeId, action) {
			var data = {
				action: action,
				combinedOfficeId: officeId
			};

			return $http.post('/api/user/officefilter', data).then(function() {
				$log.debug('Adding office filter succeeded: ' + action.toString() + ' for office id: ' + officeId.toString());
			}, function (errorResponse) {
				$log.error('Error adding office filter, status returned: ' + errorResponse.status);
				dumpErrorResponse(errorResponse);
				// TODO - error handling
			});
		}

		function removeOfficeFilter(officeId) {
			return $http.delete('/api/user/officefilter?combinedOfficeId=' + officeId.toString()).then(function() {
				$log.debug('Removing office filter succeeded for office id: ' + officeId.toString());
			}, function (errorResponse) {
				$log.error('Error removing office filter, status: ' + errorResponse.status);
				dumpErrorResponse(errorResponse);
				// TODO - error handling
			});
		}

		function dumpErrorResponse(errorResponse) {
			if (angular.mock) $log.error('Error response: ' + angular.mock.dump(errorResponse));
		}
	}
})();
